import { render, staticRenderFns } from "./GetProducts.vue?vue&type=template&id=eddbe682&"
import script from "./GetProducts.vue?vue&type=script&lang=js&"
export * from "./GetProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/boban/boban.adamovic.net/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eddbe682')) {
      api.createRecord('eddbe682', component.options)
    } else {
      api.reload('eddbe682', component.options)
    }
    module.hot.accept("./GetProducts.vue?vue&type=template&id=eddbe682&", function () {
      api.rerender('eddbe682', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/GetProducts.vue"
export default component.exports